export enum WizardTypeEnum {
    Entry = "Entry",
    Template = "Template",
    Participant = "Participant",
}
